import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';

import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import type { BankFeedTransactionAccount, BankFeedTransactionRow } from '@/domain/bankFeed/schemas';

type AccountCellRendererProps = ICellRendererParams<BankFeedTransactionRow, BankFeedTransactionAccount | null | undefined>;

const AccountCellRenderer: React.FC<AccountCellRendererProps> = ({ value }) => {
  if (!value) return null;

  const name = value.name ?? '';

  return (
    <Stack direction="row" alignItems="center" spacing={1} height="100%">
      <Avatar src={value.picture ?? undefined} alt={name} sx={{ width: 24, height: 24 }} />
      <Stack sx={{ overflow: 'hidden' }}>
        <Typography variant="body2" noWrap>
          {name}
        </Typography>
        {value.bank_code && (
          <Typography variant="caption" color="text.secondary" noWrap>
            {value.bank_code}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default AccountCellRenderer;
